// #5: for deep_linking_level
export const VALID_DEEP_LINKING_LEVELS = ["submodule", "module", "course"] as const;
export type DeepLinkingLevel = (typeof VALID_DEEP_LINKING_LEVELS)[number];

// #8: for completion_vs_accuracy
export const VALID_COMPLETION_VS_ACCURACY = ["completion", "accuracy"] as const;

// #10: for grading_type
export const VALID_GRADING_TYPES = ["deferred", "incremental", "n/a"] as const;

export interface Course {
  course_id?: number | string; // optional
  course_name: string; // template column mapped to 'name'
  // description removed from template
  deep_linking_level: string; // "Submodule/Target" | "Module" | "Course"
  completion_vs_accuracy: string; // "Completion" | "Accuracy"
  grading_enabled: boolean | string; // TRUE/FALSE
  grading_type: string; // "Deferred" | "Incremental" | "N/A"
  metadata: string | object;
  // feature_flag_id removed from template
  higher_ed?: boolean | string; // optional - "TRUE"/"FALSE"
}
export interface Module {
  landing_page: string;
  landing_page_target: string;
  module_id: string;
  name: string;
  order: number;
  summary: string;
  metadata: string | object;
}

export interface Target {
  module_id: string;
  name: string;
  order: number;
  skills_summary: string;
  target_id: string;
  target_page_summary: string;
  metadata: string | object;
}

export const VALID_ACTIVITIES = [
  "solo",
  "tutor",
  "study",
  "orchard_node",
  "orchard_node_h5p",
  "lti1p3_problem",
  "digit_problem",
  "archie_direct_url",
] as const;

export type Activity = (typeof VALID_ACTIVITIES)[number];

export const VALID_QUESTION_TYPES = ["guided", "practice", "mastery"] as const;

export type QuestionType = (typeof VALID_QUESTION_TYPES)[number];

export interface Question {
  activity_type: Activity;
  order: number;
  /**This is the MACS ID */
  problem_id: string;
  /**This is the gradarius ID */
  grd_problem_id: string;
  grd_template_id: string;
  resource_link_title: string;
  target_id: string;
  type: QuestionType;
  primary_videos: number;
  supplementary_videos: number;
  primary_quizzes: number;
  supplementary_quizzes: number;
  estimated_time_minutes: number;
  metadata: string | object;
}
